import { createSlice } from '@reduxjs/toolkit';
import { accessApi } from '@store/rtk/access';
import { selectItemType } from '@src/types';

export type AccessData = {
  id: number;
  image: string;
  firstName: string;
  lastName: string;
  active: boolean;
  email: string;
  jobTitle: string;
  phone: string;
  roles: Array<selectItemType> | null;
  sms: boolean;
  status: 'Online' | 'Away' | 'Offline';
  type: selectItemType | null;
};

type MobileAppInfoType = {
  id: number;
  payor_id: number;
  on: boolean;
  primaryColorHexCode: boolean | string;
  secondaryColorHexCode: boolean | string;
  splashPageLogoDocumentId: number;
  iconDocumentId: number;
  indicator: number;
};

type AccessSliceType = {
  accessData: {
    content: Array<AccessData>;
    last: number;
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    requestForInfiniteScroll: any;
  } | null;
  mobileAppInfo: MobileAppInfoType | null;
};

const initialState: AccessSliceType = {
  accessData: null,
  mobileAppInfo: null,
};

const handleData = (state, payload, body) => {
  return payload?.content
    ? payload?.page === 0
      ? body
      : {
          ...body,
          content: [...(state ? state.content : []), ...payload.content],
        }
    : null;
};

export const accessSlice = createSlice({
  name: 'access',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      accessApi.endpoints.getPayorMobileInfo.matchFulfilled,
      (state, { payload }) => {
        if (payload && payload.length > 0) {
          state.mobileAppInfo = { ...payload[0] };
        }
      }
    );
    builder.addMatcher(
      accessApi.endpoints.getPayorsUsers.matchFulfilled,
      (state, { payload }) => {
        const body = {
          ...payload,
          requestForInfiniteScroll: accessApi.endpoints.getPayorsUsers,
        };
        state.accessData = handleData(state.accessData, payload, body);
      }
    );
    builder.addMatcher(
      accessApi.endpoints.getPlacesUsers.matchFulfilled,
      (state, { payload }) => {
        const body = {
          ...payload,
          requestForInfiniteScroll: accessApi.endpoints.getPlacesUsers,
        };
        state.accessData = handleData(state.accessData, payload, body);
      }
    );
    builder.addMatcher(
      accessApi.endpoints.getContractorsUsers.matchFulfilled,
      (state, { payload }) => {
        const body = {
          ...payload,
          requestForInfiniteScroll: accessApi.endpoints.getContractorsUsers,
        };
        state.accessData = handleData(state.accessData, payload, body);
      }
    );
  },
});

export const selectAccess = (state: { access: AccessSliceType }) =>
  state.access;
export const {} = accessSlice.actions;
export const accessReducer = accessSlice.reducer;
